package com.eladfinish.bible.contest.text

import androidx.compose.ui.text.TextRange

data class SpannedRange(
    val spanType: SpanType,
    val textRange: TextRange,
)
